import classNames from "classnames"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getAccentColor, getTextColorClass } from "@utils/V2/color"
import { getDepartmentIcon } from "@utils/V2/department"
import React from "react"

type Props = {
  job: HiBob.JobAd
  backgroundColor: Color
}

const MinifiedJobRow = ({ job, backgroundColor }: Props) => {
  const accentColor = getAccentColor(backgroundColor)
  const DepartmentIcon = job.department
    ? getDepartmentIcon(job.department)
    : null

  return (
    <div
      aria-label={`Apply for ${job.title}`}
      className="group -mx-16 flex w-[calc(100%+32px)] flex-col items-start justify-between gap-16 border-b border-gray/10 px-14 py-[18px] text-left transition-all duration-150 last:border-b-0 hover:rounded-12 hover:border-transparent hover:bg-coal hover:shadow-md-full sm:flex-row sm:items-center"
    >
      <div className="flex flex-col gap-8">
        <Typography
          size="body-lg"
          font="grotesk"
          weight="medium"
          color={accentColor}
          text={job.title}
        />
      </div>

      <div className="flex shrink-0 items-center gap-32 md:gap-80">
        {job.department && DepartmentIcon && (
          <div className="flex w-fit items-center gap-6 rounded-8 bg-blue/20 px-10 py-6">
            <DepartmentIcon
              className={classNames(
                "size-14 shrink-0",
                getTextColorClass(Color.White)
              )}
            />
            <Typography
              size="body-sm"
              font="grotesk"
              weight="book"
              color={Color.White}
              text={job.department}
            />
          </div>
        )}
        {job.site && (
          <Typography
            size="body-sm"
            font="grotesk"
            weight="book"
            color={accentColor}
            text={job.site}
          />
        )}
        {job.employmentType && (
          <Typography
            size="body-sm"
            font="grotesk"
            weight="book"
            color={accentColor}
            text={job.employmentType}
          />
        )}
      </div>
    </div>
  )
}

export default MinifiedJobRow
